import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IBlockState } from './block-state.store';
import { ITicketListingViewModel } from '../../models/ticket';
import { CrudStatus } from '../../common/enums';
import { IBlockParameter, IBlockListingViewModel } from '../../models/block';

export const getters: GetterTree<IBlockState, IRootState> = {
  blocks: (state: IBlockState) => {
    return state.blocks;
  },
  block : (state: IBlockState ) => {
    return state.block
  },
  pagination: (state: IBlockState) => {
    return state.pagination;
  }
  , activityStatus: (state: IBlockState) => {
    return state.activityStatus;
  },
  detailActivityStatus: (state: IBlockState) => {
    return state.detailActivityStatus;
  },
  blockParameter: (state: IBlockState): IBlockParameter => {
    return state.blockParameter;
  },
  currentBlockId: (state: IBlockState): number => {
    return state.blockCurrentId;
  },
  currentBlock: (state: IBlockState): IBlockListingViewModel => {
    return state.currentBlock;
  },
  blockApartmentSidebarTickets: (state: IBlockState): ITicketListingViewModel[] => {
    return state.blockApartmentSidebarTickets;
  }
  ,
  blockApartmentInProcessTickets: (state: IBlockState): ITicketListingViewModel[] => {
    return state.blockApartmentInProcessTickets;
  }
  , blockCrudActionStatus: (state: IBlockState ) : CrudStatus => {
     return state.crudActionStatus
  }
  , blockChartsData: (state: IBlockState): any => {
    if (state.statisticData.chartsByDay.length === 0) {
      return new Array().fill(new Date().getDate())
    }
    return state.statisticData.chartsByDay;
  }
  , averageResolutionTime: (state: IBlockState): any => {
    return state.statisticData.averageResolutionTime;
  }
  , blockEntityParameter: (state: IBlockState) => {
    return state.blockEntityParameter
  },
  service: (state: IBlockState ) => {
    return state.service
  },
  loaders: (state: IBlockState ) => {
    return state.loaders
  },
  canManageDocuments: () => {
    if(!localStorage.getItem('modules')) return false
    const userModules= JSON.parse(localStorage.getItem('modules'))
    return userModules.document_management || false
  }
}



// WEBPACK FOOTER //
// ./src/store/block/block-getters.store.ts